export default {
  appliedPaymentPlanHeading: 'payment-plan',
  appliedBalanceHeading: 'applied-balance',
  paymentSubmitHeading: 'payment-heading',
  appliedGiftCertificateMessage: 'applied-gift-certificate-message',
  recaptchaSubmitHeading: 'recaptcha-heading',
};
